import { Box, Button, CircularProgress, Modal, Paper } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectLabels } from "../../../slices/language";
import { User } from "../../../api/models/user-model";

interface ResendConfirmationEmailModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  user: User | null;
  isLoading?: boolean;
}

const ResendConfirmationEmailModal = ({
  open,
  onClose,
  onConfirm,
  user,
  isLoading = false,
}: ResendConfirmationEmailModalProps) => {
  const labels = useAppSelector(selectLabels);
  const [showSuccess, setShowSuccess] = React.useState(false);

  React.useEffect(() => {
    if (!open) {
      setShowSuccess(false);
    }
  }, [open]);

  const handleConfirm = async () => {
    try {
      await onConfirm();
      setShowSuccess(true);
    } catch {
      // Parent already surfaces the error toast.
    }
  };

  const handleClose = () => {
    if (isLoading) return;
    setShowSuccess(false);
    onClose();
  };

  return (
    <Modal open={open} onClose={isLoading ? undefined : handleClose}>
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          style={{
            maxWidth: 350,
            minWidth: 350,
            width: "40%",
            boxSizing: "border-box",
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 30,
            paddingLeft: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {showSuccess ? (
            <>
              <p style={{ textAlign: "center" }}>
                {labels.resend_confirmation_email_success}
              </p>
              <div className="w-100 flex justify-content-center mt-10">
                <Button variant="contained" fullWidth onClick={handleClose}>
                  {labels.accept}
                </Button>
              </div>
            </>
          ) : (
            <>
              <p style={{ textAlign: "center" }}>
                {labels.resend_confirmation_email_confirm}{" "}
                <span style={{ fontWeight: "bold" }}>{user?.email}</span>?
              </p>
              <div className="w-100 flex gap-4 mt-10">
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleClose}
                  disabled={isLoading}
                >
                  {labels.cancel}
                </Button>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleConfirm}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    labels.continue
                  )}
                </Button>
              </div>
            </>
          )}
        </Paper>
      </Box>
    </Modal>
  );
};

export default ResendConfirmationEmailModal;
